import { removeUserRole } from "../roleCrypto";

function Header({ toggleSidebar }) {


  const logout = () => {
    localStorage.removeItem("token");
      removeUserRole();
   window.location.href = "/login";
  };

  return (
    <header className="bg-white/80 backdrop-blur-md shadow-md px-4 py-3 flex justify-between items-center">

      {/* Left */}
      <div className="flex items-center gap-3">
        <button
          onClick={toggleSidebar}
          className="md:hidden text-2xl"
        >
          ☰
        </button>

        <h1 className="text-lg font-bold text-gray-800">
          Dashboard
        </h1>
      </div>

      {/* Right */}
      <button
        onClick={logout}
        className="bg-gradient-to-r from-red-500 to-pink-500 text-white px-4 py-2 rounded-xl hover:opacity-90 transition"
      >
        Logout
      </button>

    </header>
  );
}

export default Header;